(() => {
  if (window.taffstyleBreadcrumbsReady) return;
  window.taffstyleBreadcrumbsReady = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.tf-bc__dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tf-bc__dropdown[open]').forEach((menu) => {
      const restoreFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (restoreFocus) menu.querySelector('summary').focus();
    });
  });
})();
